import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Modal, Button } from "lib/components/index";
import * as FormControl from "lib/components/FormControl";

import { stateSelector, open, close, submit } from "./index";
import FinishOrderModalForm from "./FinishOrderModalForm";

@connect(
  (state) => ({
    opened: stateSelector(state).opened,
    submitLoading: stateSelector(state).submitLoading,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        open,
        close,
        submit,
      },
      dispatch
    )
)
export default class FinishOrderModal extends React.PureComponent {
  state = {
    askOpinion: true,
  };

  handleSave = () => {
    const { close, finishOrder, onSave } = this.props;
    const { askOpinion } = this.state;
    finishOrder(askOpinion);
    close();
  };

  render() {
    const { opened, submitLoading, close, submit } = this.props;
    const { askOpinion } = this.state;
    return (
      <Modal
        open={opened}
        closeOnDimmerClick={false}
        onClose={() => {
          close();
          this.setState({ askOpinion: true });
        }}
        className="ui small modal"
      >
        <Modal.Content>
          <FinishOrderModalForm />
        </Modal.Content>
        <Modal.Actions>
          <FormControl.CheckboxFormGroup
            wrapperStyle={{ float: "left", display: "block" }}
            checked={askOpinion}
            onChange={(askOpinion) => this.setState({ askOpinion })}
            disabled={submitLoading}
            label={I18n.t("papp.orders.utils.send_opinion_request_to_customer")}
            toggle
          />
          <Button as="a" basic onClick={close} disabled={submitLoading} content={I18n.t("papp.common.cancel")} />
          <Button as="a" primary onClick={this.handleSave} disabled={submitLoading} content={"OK"} />
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/orders/FinishOrderModal/FinishOrderModal.jsx